import { Controller } from "@hotwired/stimulus"

export default class MenuController extends Controller {
  static targets = ["menu", "itemWrapper", "selectableItem", "selectedItem"]
  static classes = ["highlight"]

  connect() {
    this.setCurrentIndex()
  }

  handleKeyPress(e) {
    if (!this.menuTarget.checkVisibility()) {
      return
    }

    if (this.shouldPreventDefaultEvent(e)) {
      e.preventDefault()
    }

    switch (e.code) {
      case "Enter":
        this.selectItem(e)
        break
      case "Escape":
        this.closeMenu()
        break
      case "ArrowDown":
        this.highlightNextItem()
        break
      case "ArrowUp":
        this.highlightPreviousItem()
        break
      default:
        return
    }
  }

  shouldPreventDefaultEvent(e) {
    return ["Enter", "Escape", "ArrowDown", "ArrowUp"].includes(e.code)
  }

  selectItem() {
    this.selectableItemTargets[this.currentItemIndex].click()
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")

    this.resetToOriginalSelectedItem()
  }

  highlightNextItem() {
    const newIndex = this.itemWrapperTargets.findIndex(
      (item, index) => index > this.currentItemIndex && item.checkVisibility()
    )
    this.highlightItem(newIndex)
  }

  highlightPreviousItem() {
    const newIndex = this.itemWrapperTargets.findLastIndex(
      (item, index) => index < this.currentItemIndex && item.checkVisibility()
    )
    this.highlightItem(newIndex)
  }

  highlightItem(index) {
    if (index >= 0) {
      this.currentItemIndex = index
      this.refreshHighlight()
      this.scrollIntoView()
    }
  }

  refreshHighlight() {
    this.itemWrapperTargets.forEach((itemWrapper, index) => {
      if (index === this.currentItemIndex) {
        itemWrapper.classList.add(...this.highlightClasses)
      } else {
        itemWrapper.classList.remove(...this.highlightClasses)
      }
    })
  }

  scrollIntoView() {
    this.itemWrapperTargets[this.currentItemIndex]?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth",
    })
  }

  setCurrentIndex() {
    if (this.hasSelectedItemTarget) {
      this.currentItemIndex = this.selectableItemTargets.findIndex((item) =>
        item.isEqualNode(this.selectedItemTarget)
      )
    } else {
      this.currentItemIndex = -1
    }
  }

  resetToOriginalSelectedItem() {
    this.setCurrentIndex()
    this.refreshHighlight()
  }

  _setMenuWidth(triggerRect) {
    this.menuTarget.style.width = `${triggerRect.width}px`
  }
}
